
import { enableProdMode, LOCALE_ID, importProvidersFrom } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeNl from '@angular/common/locales/nl';
import 'moment/locale/nl';
registerLocaleData(localeNl, 'nl-NL');
import { environment } from './environments/environment';
import { AppComponent } from './app/app.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { AppRoutingModule } from '@app/app-routing.module';
import { LoginModule } from '@app/login/login.module';
import { QuillModule, QuillConfig } from 'ngx-quill';
import { ShellModule } from './app/shell/shell.module';
import { SharedModule } from '@app/shared/shared.module';
import { Angulartics2Module } from 'angulartics2';
import { MaterialModule } from '@app/material.module';
import { provideAnimations } from '@angular/platform-browser/animations';
import { withInterceptorsFromDi, provideHttpClient, withJsonpSupport } from '@angular/common/http';
import { LayoutModule } from '@angular/cdk/layout';
import { FormsModule } from '@angular/forms';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { CoreModule } from '@app/core/core.module';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { MAT_MOMENT_DATE_FORMATS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { environment as environment_1 } from '@env/environment';
import { TranslateService, TranslateModule } from '@ngx-translate/core';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
    providers: [
        importProvidersFrom(CoreModule, BrowserModule, FormsModule, LayoutModule, TranslateModule.forRoot(), MaterialModule, Angulartics2Module.forRoot({
            pageTracking: {
                clearIds: true,
                clearHash: true,
            }
        }), SharedModule, ShellModule.forRoot(), QuillModule.forRoot(<QuillConfig>{
            format: 'html',
            placeholder: null,
            modules: {
                toolbar: [
                    ['bold', 'italic'],
                    [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                ]
            },
            theme: 'snow'
        }), LoginModule, AppRoutingModule, InfiniteScrollModule),
        {
            provide: LOCALE_ID,
            useFactory: (translate: TranslateService): string => translate.currentLang !== undefined ? translate.currentLang : environment.defaultLanguage,
            deps: [TranslateService]
        },
        {
            provide: MAT_DATE_LOCALE,
            useFactory: (translate: TranslateService): string => {
                const lang = translate.currentLang ?? environment.defaultLanguage;
                return lang.split('-')[0];
            },
            deps: [TranslateService]
        },
        { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
        { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
        {
            provide: STEPPER_GLOBAL_OPTIONS,
            useValue: { displayDefaultIndicatorType: false }
        },
        {
            provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
            useValue: { appearance: 'outline' }
        },
        provideHttpClient(withInterceptorsFromDi(), withJsonpSupport()),
        provideAnimations()
    ]
})
  .catch(err => console.error(err));

